export default __webpack_public_path__ + "static/media/sfane1.c0c3890a.jpg";